var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div style=\"display: block;\" class=\"popup popup-signature\"><div class=\"head\"><h2>Signature</h2><a title=\"Close\" href=\"#\" ng-click=\"close()\" class=\"fancybox-item fancybox-close\"></a></div><div class=\"container\"><form><div style=\"width: 100%;margin: 0 auto;\" class=\"sign\"><new-signature field=\"field\" mode=\"edit\" id=\"signature_modal\" stage=\"stage\"></new-signature></div><a ng-click=\"clear_signature()\" class=\"clear-signature\">Clear Signature</a><div class=\"cf\"></div><div class=\"done-div\"><input type=\"submit\" value=\"Done\" ng-click=\"close()\" class=\"done-button\"></div></form></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/freeforms/newSignatureModal/signatureModal.jade
// module id = 351
// module chunks = 0